// removed by extract-text-webpack-plugin
module.exports = {"ScreenLGMin":"(min-width: 1200px)","ScreenXLMin":"(min-width: 1600px)","wave":"G4c93ee","waves":"G88ae32"};